import ClientDetailTabContract from '@/components/client/contract/DetailTabContract.vue'
import ClientInnerTabContractActives from '@/components/client/contract/InnerTabContractActives.vue'
import ClientInnerTabContractInactives from '@/components/client/contract/InnerTabContractInactives.vue'
import contractModalRouter from '@/router/routers/contractModal'

const contractRouter = (beforeEnter, name, singleName, basePath, tabs) => {
    const requesterType = basePath.replace('/', '')
    const activeDetailTo = `DetalheContrato${singleName}Ativos`
    const unactiveDetailTo = `DetalheContrato${singleName}Inativos
`
    return {
        beforeEnter: beforeEnter,
        name: '',
        path: `${basePath}/detalhe/:id/contratos/ativos`,
        meta: {
            requiresAuth: true,
            isEmployee: true,
            layout: 'default',
            basePath,
            singleName,
            requesterType
        },
        props: true,
        component: ClientDetailTabContract,
        children: [
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaContratosAtivos`,
                path: '',
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    basePath,
                    singleName,
                    requesterType,
                    detailTo: activeDetailTo,
                    tabs
                },
                props: true,
                component: ClientInnerTabContractActives,
                children: [
                    contractModalRouter(beforeEnter, `CadastrarContrato${singleName}AA`, ':requesterType/detalhe/:requesterId?/contratos', false, singleName, requesterType),
                    contractModalRouter(beforeEnter, activeDetailTo, ':requesterType/detalhe/:requesterId?/contratos/ativos', true, singleName, requesterType)
                ]
            },
            {
                beforeEnter: beforeEnter,
                name: `${singleName}AbaInternaContratosInativos`,
                path: `${basePath}/detalhe/:id/contratos/inativos`,
                meta: {
                    requiresAuth: true,
                    isEmployee: true,
                    layout: 'default',
                    basePath,
                    singleName,
                    requesterType,
                    detailTo: unactiveDetailTo,
                    tabs
                },
                props: true,
                component: ClientInnerTabContractInactives,
                children: [
                    contractModalRouter(beforeEnter, `CadastrarContrato${singleName}BB`, ':requesterType/detalhe/:requesterId?/contratos', false, singleName, requesterType),
                    contractModalRouter(beforeEnter, unactiveDetailTo, ':requesterType/detalhe/:requesterId?/contratos/inativos', true, singleName, requesterType)
                ]
            }
        ]
    }
}

export default contractRouter
